
export const UPDATE_USER_PICTURE = 'UPDATE_USER_PICTURE';
export const CHANGE_USER_PASSWORD = 'CHANGE_USER_PASSWORD';
export const PROFILE_LOADER = 'PROFILE_LOADER';
export const PROFILE_FAILURE = 'PROFILE_FAILURE';
export const ADD_USER_PROFILE= 'ADD_USER_PROFILE';

